/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Constraint } from './constraint';


export interface PropertyExistenceConstraint extends Constraint { 
    propertyName: string;
    operator: string;
}

export namespace PropertyExistenceConstraint {
    export type ExistenceOperatorEnum = 'IS_NULL' | 'IS_NOT_NULL';
    export const ExistenceOperatorEnum = {
        ISNULL:'IS_NULL' as ExistenceOperatorEnum,
        ISNOTNULL:'IS_NOT_NULL' as ExistenceOperatorEnum
    };
}